import { useEffect } from 'react'

declare global {
    interface Window {
        dataLayer: any[]
    }
}

export const useGTM = () => {
    useEffect(() => {
        window.dataLayer = window.dataLayer || []
    }, [])

    const pushEvent = (eventName: string, eventParams: Record<string, any> = {}) => {
        if (typeof window !== 'undefined') {
            window.dataLayer.push({
                event: eventName,
                ...eventParams,
            })
        }
    }
    return { pushEvent }
}

